import axios from 'axios';

import http from '@/services/http.js';

const JIANYING_API = '/videoapi/jianying';

export const fetchJianyingServiceHealth = async () => {
  const response = await http.get(`${JIANYING_API}/service/health`);
  return response.data.data;
};

export const fetchJianyingTemplates = async (params = {}) => {
  const response = await http.get(`${JIANYING_API}/templates`, { params });
  return response.data.data || [];
};

export const fetchJianyingTemplateAvailability = async (templateIds) => {
  const response = await http.post(`${JIANYING_API}/templates/availability`, {
    template_ids: templateIds,
  });
  return response.data.data || [];
};

export const createJianyingTemplate = async (payload) => {
  const response = await http.post(`${JIANYING_API}/templates`, payload);
  return response.data.data;
};

export const inspectJianyingTemplate = async (draftName) => {
  const response = await http.post(`${JIANYING_API}/templates/inspect`, {
    draft_name: draftName,
  });
  return response.data.data;
};

export const updateJianyingTemplate = async (templateId, payload) => {
  const response = await http.put(
    `${JIANYING_API}/templates/${templateId}`,
    payload,
  );
  return response.data.data;
};

export const deleteJianyingTemplate = async (templateId) => {
  const response = await http.delete(`${JIANYING_API}/templates/${templateId}`);
  return response.data.data;
};

export const scanJianyingTemplate = async (templateId, payload = {}) => {
  const response = await http.post(
    `${JIANYING_API}/templates/${templateId}/scan`,
    payload,
  );
  return response.data.data;
};

export const fetchJianyingTemplate = async (templateId) => {
  const response = await http.get(`${JIANYING_API}/templates/${templateId}`);
  return response.data.data;
};

export const createJianyingTemplateGroup = async (templateId, payload) => {
  const response = await http.post(
    `${JIANYING_API}/templates/${templateId}/groups`,
    payload,
  );
  return response.data.data;
};

export const updateJianyingTemplateGroup = async (templateId, groupId, payload) => {
  const response = await http.put(
    `${JIANYING_API}/templates/${templateId}/groups/${groupId}`,
    payload,
  );
  return response.data.data;
};

export const deleteJianyingTemplateGroup = async (templateId, groupId) => {
  const response = await http.delete(
    `${JIANYING_API}/templates/${templateId}/groups/${groupId}`,
  );
  return response.data.data;
};

export const updateJianyingTemplateSlot = async (templateId, slotId, payload) => {
  const response = await http.put(
    `${JIANYING_API}/templates/${templateId}/slots/${slotId}`,
    payload,
  );
  return response.data.data;
};

export const createJianyingCopyPreset = async (templateId, payload) => {
  const response = await http.post(
    `${JIANYING_API}/templates/${templateId}/copy-presets`,
    payload,
  );
  return response.data.data;
};

export const updateJianyingCopyPreset = async (templateId, presetId, payload) => {
  const response = await http.put(
    `${JIANYING_API}/templates/${templateId}/copy-presets/${presetId}`,
    payload,
  );
  return response.data.data;
};

export const deleteJianyingCopyPreset = async (templateId, presetId) => {
  const response = await http.delete(
    `${JIANYING_API}/templates/${templateId}/copy-presets/${presetId}`,
  );
  return response.data.data;
};

export const uploadJianyingTemplatePreview = async (file) => {
  const extension = String(file.name || '').split('.').pop()?.toLowerCase();
  const contentType = file.type || (extension ? `video/x-${extension}` : '');
  const signingResponse = await http.post(
    `${JIANYING_API}/templates/preview/upload-url`,
    {
      file_name: file.name,
      content_type: contentType,
    },
  );
  const signed = signingResponse.data.data;
  await axios.put(signed.uploadUrl || signed.upload_url, file, {
    headers: signed.headers,
  });
  return signed;
};
